<ngx-spinner bdColor="rgba(51,51,51,0.55)" size="medium" color="#fff" type="line-spin-clockwise-fade"
    [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div class="row ml-0">
    <div class="col-12">
        <h2 class="page-title" tabindex="0">{{'user.user_details' | translate}}</h2>
    </div>
</div>
<div class="col-12 mb-2">
    <xng-breadcrumb separator=" > ">
        <ng-container *xngBreadcrumbItem="let breadcrumb">
            <span *ngIf="breadcrumb">
                {{ 'breadcrumb.' + breadcrumb | translate }}
            </span>
        </ng-container>
    </xng-breadcrumb>
</div>
<div *ngIf="_userToView && _userToView.user?.active == 6" class="refreshBox row text-wrap text-break p-2 m-0">
    <div class="col-12">
        <strong> {{ 'user.delete_reason' | translate }} {{ _userToView.user.deleteReason }} </strong>
    </div>
</div>
<br>
<div class="card col-12 p-5">
    <div class="row">
        <div class="col-2 text-center mt-auto mb-auto">
            <img class="img-round"
                [src]="_userToView.userPhoto ? _userToView.userPhoto : 'assets/images/default-user.jpeg'" height="100px"
                width="100px" title="{{ _userToView.firstName }}"
                alt="{{ _userToView.firstName }} {{_userToView.lastName}}" />
        </div>
        <br>
        <div class="col-5">
            <table class="w-100">
                <tr>
                    <th colspan="2" class="uppercase h5 dark-gray-text" scope="col">
                        {{ 'user.user_information' | translate }}
                    </th>
                </tr>
                <tr>
                    <td>
                        <strong>
                            {{ 'user.full_name' | translate }}:
                        </strong>
                    </td>
                    <td>
                        {{ _userToView.firstName }} {{_userToView.lastName}}
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>
                            {{ 'user.phone_number' | translate }}:
                        </strong>
                    </td>
                    <td>
                        {{ _userToView.phoneNumber }}
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>
                            {{ 'user.res_phone_number' | translate }}:
                        </strong>
                    </td>
                    <td>
                        {{ _userToView.phoneNumberResidence }}
                    </td>
                </tr>
                <tr>
                    <td class="pt-0">
                        <strong>
                            {{ 'user.address' | translate }}:
                        </strong>
                    </td>
                    <td class="text-break">
                        {{ _userToView.fullAddress }}
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>
                            {{ 'general.email' | translate }}:
                        </strong>
                    </td>
                    <td class="text-break">
                        {{ _userToView.userEmail }}
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>
                            {{ 'general.role' | translate }}:
                        </strong>
                    </td>
                    <td>
                        {{ _userToView.userRole | translate }}
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>
                            {{ 'user.dob' | translate }}:
                        </strong>
                    </td>
                    <td>
                        {{ dob | translate }}
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>
                            {{ 'user.gender' | translate }}:
                        </strong>
                    </td>
                    <td>
                        {{ _userToView.gender | translate }}
                    </td>
                </tr>
                                <tr>
                    <td>
                        <strong>
                            {{ 'user.children' | translate }}:
                        </strong>
                    </td>
                    <td>
                        {{ _userToView.children | translate }}
                    </td>
                </tr>
                                <tr>
                    <td>
                        <strong>
                            {{ 'user.motor_vehicle' | translate }}:
                        </strong>
                    </td>
                    <td>
                        {{ _userToView.motor_vehicle | translate }}
                    </td>
                </tr>
                                <tr>
                    <td>
                        <strong>
                            {{ 'user.odim' | translate }}:
                        </strong>
                    </td>
                    <td>
                        {{ _userToView.odim | translate }}
                    </td>
                </tr>
            </table>
        </div>
        <div class="col-5">
            <table colspan="2" class="w-100">
                <tr>
                    <th colspan="2" class="uppercase h5 dark-gray-text" scope="col">
                        {{ 'user.primary_contact' | translate }}
                    </th>
                </tr>
                <tr>
                    <td>
                        <strong>
                            {{ 'user.name' | translate }}:
                        </strong>
                    </td>
                    <td class="text-break">
                        {{ _userToView.primaryContactName }}
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>
                            {{ 'user.phone_number' | translate }}:
                        </strong>
                    </td>
                    <td>
                        {{ _userToView.primaryContactPhoneNumber }}
                    </td>
                </tr>
                <tr>
                    <th colspan="2" class="uppercase pt-2 h5 dark-gray-text">
                        {{ 'user.secondary_contact' | translate }}
                    </th>
                </tr>
                <tr>
                    <td>
                        <strong>
                            {{ 'user.name' | translate }}:
                        </strong>
                    </td>
                    <td class="text-break">
                        {{ _userToView.secondaryContactName }}
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>
                            {{ 'user.phone_number' | translate }}:
                        </strong>
                    </td>
                    <td>
                        {{ _userToView.secondaryContactPhoneNumber }}
                    </td>
                </tr>
                <br>
                <tr
                    *ngIf="geoAssignment && (_userToView.userRole == 'SecurityAgent' || _userToView.userRole == 'Supervisor')">
                    <td>
                        <strong>
                            {{ 'user.assigned_zone' | translate }}:
                        </strong>
                    </td>
                    <td class="text-break">
                        {{ _userToView.assignedZone }} <span
                            *ngIf="_userToView.assignedZone && _userToView.assignedZone != '' && !_userToView.activeZone"
                            class="error">({{'general.inactive' | translate}})</span>
                    </td>
                </tr>
            </table>


        </div>
        <div *ngIf="fieldOption" class="row">
            <div class="col-2"></div>
            <div class="col-5">
                <table colspan="2" class="w-100">
                    <tr>
                        <th colspan="2" class="uppercase h5 dark-gray-text" scope="col">
                            {{ 'setting.additional_info' | translate }}
                        </th>
                    </tr>
                    <tr *ngFor="let fields of c_fields; let i = index">
                        <td class="align-top" *ngIf="i<15">
                            <strong>
                                {{ fields.field }}:
                            </strong>
                        </td>
                        <td *ngIf="i<15">
                            {{ fields.fieldValue }}
                        </td>
                    </tr>
                </table>
            </div>
            <div class="col-5">
                <table colspan="2" class="w-100">
                    <tr>
                        <td height=25px></td>
                    </tr>
                    <tr *ngFor="let fields of c_fields; let i = index">
                        <td class="align-top" *ngIf="i>14">
                            <strong>
                                {{ fields.field }}:
                            </strong>
                        </td>
                        <td *ngIf="i>14">
                            {{ fields.fieldValue }}
                        </td>
                    </tr>
                </table>
            </div>


        </div>
    </div>
    <br>
</div>


<div class="card col-12 p-5 mt-4">
    <div class="row">
        <div class="col-1"></div>
        <div class="row w-100">
            <!-- <div class="col-2"></div> -->
            <div class="col-10">
                <h5 class="mb-4 uppercase">{{ 'aggressor.list_title' | translate }}</h5>
            </div>
        </div>

        <div *ngIf="aggressors && aggressors.length > 0" class="row w-100">
            <!-- Remove the col-2 and col-10, use full width -->

            <div class="col-12">
                <div class="card-body">
                    <!-- <h3 class="mb-4">{{ 'aggressor.list_title' | translate }}</h3> -->
                    <div class="col-2"></div>


                    <!-- Compact filter row -->
                    <div class="row mb-3">
                        <div class="col-lg-3 col-md-4 mb-2">
                            <label for="nameFilter" class="form-label small">{{ 'aggressor.filter_by_name' |
                                translate }}</label>
                            <input type="text" id="nameFilter" class="form-control form-control-sm"
                                [(ngModel)]="filters.name" (ngModelChange)="applyFilters()"
                                placeholder="{{ 'aggressor.search_name' | translate }}">
                        </div>

                        <div class="col-lg-2 col-md-3 mb-2">
                            <label for="statusFilter" class="form-label small">{{ 'aggressor.filter_by_status' |
                                translate }}</label>
                            <select id="statusFilter" class="form-control form-control-sm" [(ngModel)]="filters.status"
                                (ngModelChange)="applyFilters()">
                                <option value="">{{ 'general.all' | translate }}</option>
                                <option value="1">{{ 'aggressor.status_active' | translate }}</option>
                                <option value="3">{{ 'aggressor.status_inactive' | translate }}</option>
                            </select>
                        </div>
                        <!-- 
                        <div class="col-lg-2 col-md-3 mb-2">
                            <label for="startDateFilter" class="form-label small">{{ 'aggressor.filter_start_date' |
                                translate }}</label>
                            <input type="text" id="startDateFilter" class="form-control form-control-sm"
                                [(ngModel)]="filters.startDate" (ngModelChange)="applyFilters()"
                                placeholder="MM/DD/YYYY">
                        </div>

                        <div class="col-lg-2 col-md-3 mb-2">
                            <label for="endDateFilter" class="form-label small">{{ 'aggressor.filter_end_date' |
                                translate }}</label>
                            <input type="text" id="endDateFilter" class="form-control form-control-sm"
                                [(ngModel)]="filters.endDate" (ngModelChange)="applyFilters()" placeholder="MM/DD/YYYY">
                        </div> -->
<!-- 
                        <div class="col-lg-3 col-md-3 mb-2">
                            <label for="startDateFilter" class="form-label small">
                                {{ 'aggressor.filter_start_date' | translate }}
                            </label><br>
                            <mat-form-field class="mm-10 w-100">
                                <input id="startDateFilter" matInput [(ngModel)]="filters.startDate"
                                    [matDatepicker]="startDateFilterPicker" (ngModelChange)="applyFilters()" readonly>
                                <mat-datepicker-toggle matSuffix [for]="startDateFilterPicker"></mat-datepicker-toggle>
                                <mat-datepicker #startDateFilterPicker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-3 col-md-3 mb-2">
                            <label for="endDateFilter" class="page-title mt-1 mr-1 text-dark mb-0">
                                {{ 'aggressor.filter_end_date' | translate }}
                            </label><br>
                            <mat-form-field class="mm-10 w-100">
                                <input id="endDateFilter" matInput [(ngModel)]="filters.endDate"
                                    [matDatepicker]="endDateFilterPicker" [min]="filters.startDate"
                                    (ngModelChange)="applyFilters()" readonly>
                                <mat-datepicker-toggle matSuffix [for]="endDateFilterPicker"></mat-datepicker-toggle>
                                <mat-datepicker #endDateFilterPicker></mat-datepicker>
                            </mat-form-field>
                        </div> -->

                        <div class="col-lg-1 col-md-2 mb-2 d-flex align-items-end">
                            <button type="button" class="btn btn-outline-secondary btn-sm text-danger"
                                (click)="clearFilters()" [title]="'general.clear_filters' | translate">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Table with horizontal scroll -->
                <div class="table-responsive-md col-12">

                    <table class="table table-hover aggressor-table">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col" style="width: 150px;">{{ 'aggressor.image' | translate }}</th>
                                <th scope="col" style="width: 30%;">{{ 'aggressor.addresses' | translate }}</th>
                                <th scope="col" style="width: 140px;">{{ 'aggressor.order_number' | translate }}
                                </th>
                                <th scope="col" style="width: 140px;">{{ 'aggressor.validity_period' | translate }}
                                </th>
                                <th scope="col" style="width: 100px;">{{ 'aggressor.status' | translate }}</th>
                                <th scope="col" style="width: 100px;" class="text-center">{{ 'aggressor.actions' |
                                    translate
                                    }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Loop through FILTERED aggressors -->
                            <tr *ngFor="let aggressor of filteredAggressors; let idx = index" class="aggressor-row">

                                <!-- Image + Name Column (Combined) -->
                                <td class="aggressor-image-cell">
                                    <div class="d-flex flex-column align-items-center">
                                        <div class="aggressor-image-container-small mb-2">
                                            <img [src]="aggressor?.imageUrl ? aggressor?.imageUrl : 'assets/images/default-user.jpeg'"
                                                [alt]="aggressor?.aggressorName" class="aggressor-image-small">
                                        </div>
                                        <div class="text-center">
                                            <strong class="aggressor-name">{{ aggressor.aggressorName }}</strong>
                                        </div>
                                    </div>
                                </td>

                                <!-- Addresses Column (WIDER) -->
                                <td class="align-top pt-3">
                                    <div *ngIf="aggressor.aggressorPrimaryAddress" class="mb-2">
                                        <small class="text-muted d-block">{{ 'aggressor.primary' | translate
                                            }}:</small>
                                        <span class="address-text">{{ aggressor.aggressorPrimaryAddress }}</span>
                                    </div>
                                    <div *ngIf="aggressor.aggressorSecondaryAddress">
                                        <small class="text-muted d-block">{{ 'aggressor.secondary' | translate
                                            }}:</small>
                                        <span class="address-text">{{ aggressor.aggressorSecondaryAddress }}</span>
                                    </div>
                                </td>

                                <!-- Order Number Column -->
                                <td class="align-middle">
                                    {{ aggressor.protectionOrderNumber }}
                                </td>

                                <!-- Validity Period Column -->
                                <td class="align-middle">
                                    <div class="validity-dates">
                                        {{ aggressor.protectionOrderStartDate | date:'MM/dd/yyyy' }}
                                        <span class="d-block text-muted small">a</span>
                                        {{ aggressor.protectionOrderEndDate | date:'MM/dd/yyyy' }}
                                    </div>
                                </td>

                                <!-- Status Column -->
                                <td class="align-middle text-center">
                                    <span [ngClass]="{
                                    'badge badge-success': aggressor.status === 1,
                                    'badge badge-secondary': aggressor.status === 2,
                                    'badge badge-warning': aggressor.status === 3,
                                    'badge badge-danger': aggressor.status === 4,
                                    'badge badge-info': aggressor.status === 5
                                }">
                                        {{ getStatusText(aggressor.status) }}
                                    </span>
                                </td>


                                <!-- Actions Column -->
                                <td class="align-middle text-center">
                                    <div class="dropdown" ngbDropdown>
                                        <button ngbDropdownToggle class="btn btn-default cursor" tabindex="0"
                                            [title]="'user.user_actions' | translate">
                                            <i class="fa fa-ellipsis-v" [title]="'aggressor.actions' | translate "></i>
                                        </button>

                                        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
                                            <!-- Edit Option -->
                                            <button ngbDropdownItem [routerLink]="[aggressor.id]"
                                                routerLinkActive="active" [title]="'aggressor.edit' | translate">
                                                <i class="fa fa-pencil"></i> {{ 'aggressor.edit' | translate }}
                                            </button>

                                            <!-- Delete Option -->
                                            <button ngbDropdownItem (click)="onDeleteAggressor(aggressor)"
                                                [title]="'aggressor.delete' | translate">
                                                <i class="fa fa-trash"></i> {{ 'aggressor.delete' | translate }}
                                            </button>
                                        </div>
                                    </div>
                                </td>

                            </tr>

                            <!-- No results after filtering -->
                            <tr *ngIf="filteredAggressors.length === 0 && aggressors.length > 0">
                                <td colspan="6" class="text-center text-muted py-5">
                                    <i class="fa fa-search fa-2x mb-2"></i><br>
                                    {{ 'general.no_results' | translate }}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>

            </div>


        </div>
    </div>

    <!-- No aggressors message -->
    <div *ngIf="!aggressors || aggressors.length === 0" class="row">
        <div class="col-2"></div>
        <div class="col-8">
            <p class="text-muted text-center">{{ 'aggressor.no_records' | translate }}</p>
        </div>
        <div class="col-2"></div>


    </div>
    <div class="text-right mt-3">
        <button id="add_user" type="button" title="{{'user.add_user' | translate}}" routerLink='aggressor'
            routerLinkActive="active" class="btn btn-green btn-h-green btn-group">
            <i class="fa fa-plus"></i><span class="text-center w-100">{{'aggressor.add_new' | translate}}</span>
        </button>
    </div>

</div>

<ng-template #deleteAggressorModal let-modal>
    <div class="modal-header bg-danger text-white">
        <h5 class="modal-title">
            <i class="fa fa-exclamation-triangle"></i>
            {{ 'aggressor.confirm_delete_title' | translate }}
        </h5>
        <button type="button" class="btn-close" (click)="modal.dismiss()" aria-label="Close"></button>
    </div>

    <div class="modal-body">
        <p>{{ 'aggressor.confirm_delete_message' | translate }}</p>

        <!-- Aggressor Info -->
        <div class="alert alert-warning" *ngIf="aggressorToDelete">
            <strong>{{ aggressorToDelete?.aggressorName }}</strong><br>
            <small>
                {{ 'aggressor.order_number' | translate }}: {{ aggressorToDelete?.protectionOrderNumber }}
            </small>
        </div>

        <!-- Delete Reason Input -->
        <!-- <div class="form-group">
            <label for="deleteReason">
                {{ 'aggressor.delete_reason' | translate }}
            </label>
            <textarea id="deleteReason" class="form-control" rows="3" [(ngModel)]="deleteReason" maxlength="200"
                placeholder="{{ 'aggressor.delete_reason_placeholder' | translate }}">
      </textarea>
            <small class="text-muted">{{ deleteReason?.length || 0 }}/200</small>

            <div *ngIf="deleteReasonError" class="text-danger mt-1">
                <small>{{ 'aggressor.delete_reason_required' | translate }}</small>
            </div>
        </div> -->

        <p class="text-muted small">
            <i class="fa fa-info-circle"></i>
            {{ 'aggressor.delete_warning' | translate }}
        </p>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
            <i class="fa fa-times"></i> {{ 'general.cancel' | translate }}
        </button>
        <button type="button" class="btn btn-danger" (click)="confirmDelete(); modal.close()">
            <i class="fa fa-trash"></i> {{ 'general.delete' | translate }}
        </button>
    </div>
</ng-template>